<!-- eslint-disable -->
<template>
  <CommonPages id="about" classs="about-page" titlePrefix="About Us - Zephyrcade"
    metaDescription="Zephyrcade is a digital media trading platform that connects advertisers and publishers. We provide efficient ad placement, real-time analytics, and smart optimization tools to maximize performance and revenue.">
    <div class="page-header"></div>
    <section class="about-story-section">
      <div class="about-story-section__content">
        <h1 class="about-story-section__title">Our story</h1>
        <p class="about-story-section__description">
          Founded by industry veterans, our company aims to simplify ad trading with cutting-edge
          technology and personalized support.
        </p>
      </div>
      <div class="about-story-section__image-container">
        <img src="@/assets/story-1.png" alt="Our story" class="about-story-section__image">
      </div>
    </section>
    <section class="about-connect-section">
      <div class="about-connect-section__image-container">
        <img src="@/assets/story-2.png" alt="Connecting advertisers"
          class="about-connect-section__image">
      </div>
      <div class="about-connect-section__content">
        <h2 class="about-connect-section__title">Connecting advertisers through a seamless and
          transparent platform</h2>
        <p class="about-connect-section__description">
          Over the years, we’ve helped hundreds of clients worldwide efficiently buy and sell
          advertising inventory, driving measurable growth. Committed to innovation and excellence,
          we continuously evolve to meet the dynamic needs of the digital advertising ecosystem.
        </p>
      </div>
    </section>
  </CommonPages>
</template>

<script>
import CommonPages from '@/pages/components/page_common.vue';
import '@/css/about.scss';

export default {
  name: 'About',
  components: {
    CommonPages,
  },
};
</script>
